var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-select',{attrs:{"store":_vm.store,"translation-root":_vm.translationRoot,"prop-name":_vm.propName,"hide-label":_vm.hideLabel,"options":_vm.taxRateOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }